// Theme colours for code that cannot use Tailwind classes (SVG/recharts props,
// inline styles, <canvas>). Every value points at a token in src/theme.css, so
// these follow the active theme and a rebrand never needs to touch components.

/** `rgb(var(--token))`, optionally with alpha. Works in inline styles and SVG attributes. */
export const cssVar = (name: string, alpha?: number): string =>
  alpha == null ? `rgb(var(${name}))` : `rgb(var(${name}) / ${alpha})`;

/**
 * Resolve a token to a concrete `rgb(r, g, b)` string. Needed for <canvas>,
 * which cannot parse `var()`. Falls back to mid grey if the token is missing.
 */
export function resolveToken(name: string): string {
  try {
    const v = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
    if (v) return `rgb(${v.split(/\s+/).join(", ")})`;
  } catch { /* SSR / no DOM */ }
  return "rgb(128, 128, 128)";
}

/** Status series used by charts (correct / wrong / skipped / pending). */
export const chartColors = {
  correct: cssVar("--app-ok400"),
  wrong:   cssVar("--app-d400"),
  skipped: cssVar("--app-warn400"),
  pending: cssVar("--app-info400"),
  axis:    cssVar("--app-t400"),
  axisMuted: cssVar("--app-t600"),
  label:   cssVar("--app-t300"),
  grid:    cssVar("--app-ink", 0.05),
  line:    cssVar("--app-ink", 0.1),
  cursor:  cssVar("--app-ink", 0.04),
  tooltipBg: cssVar("--app-surface", 0.95),
  tooltipBorder: cssVar("--app-ink", 0.1),
};
